import { useMemo } from 'react';

import { NamedEntityForEpisodeItem } from '@insights_module/types/ContextualAndEntity';
import { NAMED_ENTITY_TYPE } from '@insights_module/constants/contextualAndEntity';
import { useSelectedEpisodeDetails } from '@insights_module/hooks/useGraphqlAudioDetails';

export const useEpisodeNamedEntities = () => {
  const { data: selectedEpisodeDetails, isLoading } = useSelectedEpisodeDetails();

  const namedEntities = useMemo(() => {
    const namedEntitiesData = (selectedEpisodeDetails?.named_entities ||
      []) as NamedEntityForEpisodeItem[];

    // filter out entities that are not in the list of types we want to show
    // Sort by mentions desc
    return namedEntitiesData
      .filter((entity) => Object.values(NAMED_ENTITY_TYPE).includes(entity.type))
      .sort((a, b) => {
        if (a.timestamps.length > b.timestamps.length) {
          return -1;
        }
        if (a.timestamps.length < b.timestamps.length) {
          return 1;
        }
        return 0;
      });
  }, [selectedEpisodeDetails?.named_entities]);

  return {
    namedEntities,
    isLoading,
  };
};
